const AuthConfiguration = {
  authority: 'http://localhost:5000',
  clientId: 'local-field-service-app.revers.io',
  scope: 'openid email api',
};

export default AuthConfiguration;
